import SEO from '../components/SEO';

const RefundsPage = () => {
  return (
    <>
      <SEO
        title="Cancellation & Refund Policy"
        description="Learn about AdOnRoads' cancellation and refund policy for billboard bookings."
      />

      <div className="pt-24 pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-secondary mb-6">Cancellation & Refund Policy</h1>
          <p className="text-gray-600 mb-8">Effective Date: January 1, 2025</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">1. Cancellation Policy</h2>
              <p className="text-gray-700 mb-4">
                At AdOnRoads, we understand that plans may change. We strive to provide flexible cancellation options while maintaining fairness to all parties involved.
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                  <strong>Cancellations allowed up to 7 days before campaign start:</strong> You may cancel your billboard booking without penalty if the cancellation is made at least 7 days before the scheduled campaign start date.
                </li>
                <li>
                  <strong>Cancellations within 7 days of campaign start:</strong> Cancellations made within 7 days of the campaign start date may incur a cancellation fee of up to 25% of the booking amount.
                </li>
                <li>
                  <strong>No cancellations after campaign start:</strong> Once a campaign has begun, cancellations are not permitted, and no refunds will be issued.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">2. Refund Processing</h2>
              <p className="text-gray-700 mb-4">
                Approved refunds will be processed according to the following terms:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                  <strong>Processing Time:</strong> Refunds will be processed within 7-10 working days from the date of cancellation approval.
                </li>
                <li>
                  <strong>Refund Method:</strong> Refunds will be credited to the original payment method used during booking.
                </li>
                <li>
                  <strong>Partial Refunds:</strong> If a cancellation fee applies, the refund amount will be adjusted accordingly.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">3. Non-Refundable Situations</h2>
              <p className="text-gray-700 mb-4">
                Refunds will not be issued in the following circumstances:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Active campaigns that have already started</li>
                <li>Completed campaigns</li>
                <li>Bookings cancelled after the campaign start date</li>
                <li>Bookings where the advertiser failed to provide campaign materials on time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">4. Force Majeure</h2>
              <p className="text-gray-700 mb-4">
                In cases of unforeseen circumstances beyond our control (natural disasters, government restrictions, etc.), we will work with you to reschedule your campaign or provide an appropriate refund or credit.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">5. How to Request a Cancellation</h2>
              <p className="text-gray-700 mb-4">
                To cancel your booking and request a refund:
              </p>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li>Log into your AdOnRoads account</li>
                <li>Navigate to your active bookings</li>
                <li>Select the booking you wish to cancel</li>
                <li>Click "Request Cancellation" and provide a reason</li>
                <li>Our team will review your request and respond within 2 business days</li>
              </ol>
              <p className="text-gray-700 mt-4">
                Alternatively, you can email us at{' '}
                <a href="mailto:support@adonroads.com" className="text-accent hover:underline">
                  support@adonroads.com
                </a>{' '}
                with your booking ID and cancellation request.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">6. Questions?</h2>
              <p className="text-gray-700">
                If you have any questions about our cancellation and refund policy, please contact us at{' '}
                <a href="mailto:support@adonroads.com" className="text-accent hover:underline">
                  support@adonroads.com
                </a>
                . We're here to help!
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundsPage;
